<template>
    <div
      v-if="Object.keys(errors).length"
      class="login-alert"
      role="alert"
    >
      <icon name="circle-alert" size="20" />
  
      <div class="login-alert__messages">
        <p
          v-for="(messages, field) in errors"
          :key="field"
        >
          {{ Array.isArray(messages) ? messages[0] : messages }}
        </p>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'LoginAlert',
  
    props: {
      errors: {
        type: Object,
        default: () => ({})
      }
    }
  }
  </script>